// @flow
import loadable from '@loadable/component'

// TODO: Uncomment this code when elementary school was start
// import { useStore } from 'effector-react'
// import { Media } from 'view/molecules/media'

// import { UserService } from 'services/user'

// const ElementaryHeader = loadable(
//   () =>
//     import(/* webpackChunkName: "elementary_navigation" */ 'features/elementary-menu/organisms/header/mobile-header'),
//   {
//     fallback: null,
//   }
// )

const MainHeader = loadable(() => import(/* webpackChunkName: "main_navigation" */ './main-header'), {
  fallback: null,
})

export const Header = () => {
  // const { user } = useStore(UserService.getStore())

  // if (process.env.REACT_APP_EXTERNAL === 'true') return <MainHeader />

  // if (user.isElementaryPupil) {
  //   return (
  //     <Media large tablet mobile>
  //       <ElementaryHeader />
  //     </Media>
  //   )
  // }

  return <MainHeader />
}
